import DisqualificationEmailTemplate from './DisqualificationEmailTemplate';

export default DisqualificationEmailTemplate;
